import { GetterTree } from 'vuex'
import { ContractorState } from '@/store/contractors/state'
import { Contractor } from '@/interfaces/contractor'

export type Getters = {
    getCurrentContractor(state: ContractorState): Contractor
    getReviewContractor(state: ContractorState): Contractor
    getContractorsList(state: ContractorState): Contractor[]
}

export const getters: GetterTree<ContractorState, ContractorState> & Getters = {
    getCurrentContractor (state) {
        return state.current
    },
    getReviewContractor (state) {
        return state.reviewContractor
    },
    getContractorsList (state) {
        return state.list
    }
}